<script>
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Switch from '@/Components/Switch.svelte';
	// Partials
	import ClassificationSelect from '@/Partials/Tracks/_ClassificationSelect.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let race;

	let classificationId = ((race.classification && race.classification.id) || 0).toString();
	let wholeMeeting = false;
	let sending = false;

	function onClickSaveClassification() {
		sending = true;
		if (wholeMeeting) {
			MeetingStore.updateMeetingClassification(race.meeting_id, classificationId, race.id)
				.then(() => {
					notify({
						type: 'success',
						title: 'All Races in Meeting',
						message: 'Classification updated',
						timeout: 3
					});
				})
				.catch(() => {
					notify({
						type: 'danger',
						title: 'All Races in Meeting',
						message: 'Failed to update classification',
						timeout: 3
					});
				})
				.finally(() => (sending = false));
		} else {
			RaceStore.updateRaceClassification(race.id, classificationId)
				.then(() => {
					notify({
						type: 'success',
						title: `Race ${race.race_number}`,
						message: 'Classification updated',
						timeout: 3
					});
				})
				.catch(() => {
					notify({
						type: 'danger',
						title: `Race ${race.race_number}`,
						message: 'Failed to update classification',
						timeout: 3
					});
				})
				.finally(() => (sending = false));
		}
	}
</script>

<div class="flex items-center justify-center">
	<div class="mr-2">
		<div>Update classification:</div>
		<div class="text-xs italic text-right text-gray-500">(replaces all overrides)</div>
	</div>
	<ClassificationSelect className="w-1/4" name="race_classification" bind:selectedClassificationId={classificationId} />
	<div class="flex items-center justify-center w-1/6 ml-2 form-input">
		<div class={!wholeMeeting ? 'font-bold' : ''}>Race</div>
		<Switch name="wholeMeeting" bind:checked={wholeMeeting} small={true} className="mx-1" />
		<div class={wholeMeeting ? 'font-bold' : ''}>Meeting</div>
	</div>
	<LoadingButton
		on:click={onClickSaveClassification}
		loading={sending}
		className="px-4 py-2 text-white bg-black rounded-md hover:bg-grey ml-4"
		>Save
	</LoadingButton>
</div>
